export default "__VITE_ASSET__C8Tzu9mn__"